module.exports = __webpack_public_path__ + "static/og_banner-192694cd26b6b81162ff382d189738fc.png";